// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://aykvienymvihwrhyunuf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF5a3ZpZW55bXZpaHdyaHl1bnVmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM2MTk5OTIsImV4cCI6MjA2OTE5NTk5Mn0.tj8IoUKib4wOd9FG90Gfexlr1HtT8TV63wNbypAsKfA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});